<template>
  <div
    v-if="isToastVisibile"
    class="fixed inset-x-0 max-w-lg md:text-xl mx-auto overflow-hidden rounded shadow-2xl top-0 z-50 mt-4"
  >
    <notification-app
      class="pr-10"
      dusk="notification_message"
      :icon="$store.state.toast_icon"
      :type="$store.state.toast_type"
      v-html="$store.state.toast_message"
    >
    </notification-app>
    <v-button
      dusk="hide_toast"
      @click="clearToast()"
      class="absolute right-0 top-0"
      icon="fas fa-lg fa-times p-2 leading-4"
      small
      color="red-600"
    />
    <div class="absolute right-0 bottom-0 text-xxs m-3">{{ __('Anzeige endet') }} {{ duration }}</div>
  </div>
</template>

<script>
import { duration } from 'moment';
export default {
  props: ['type', 'icon', 'message'],
  data() {
    return {
      duration: 15,
    };
  },
  methods: {
    clearToast() {
      this.$store.commit('set_toast_message', null);
    },
    setMessage(value) {
      this.duration = 15;
      this.$store.commit('set_toast_message', value);
    },
    setIcon(value) {
      this.$store.commit('set_toast_icon', value);
    },
    setType(value) {
      this.$store.commit('set_toast_type', value);
    },
    set_toast_visibility(value) {
      this.$store.commit('set_toast_visibility', value);
    },
  },
  computed: {
    isToastVisibile() {
      return !!this.$store.state.toast_message;
    },
  },
  mounted() {
    this.type ? this.setType(this.type) : null;
    this.icon ? this.setIcon(this.icon) : null;
    this.message ? this.setMessage(this.message) : null;
    setInterval(() => {
      if (this.duration > 0) {
        this.duration = this.duration - 1;
      }
      if (this.duration === 0) {
        this.clearToast();
        this.duration = undefined;
      }
    }, 1000);
  },
};
</script>
